import { render, staticRenderFns } from "./BusinessCoefficient.vue?vue&type=template&id=34c67702&scoped=true"
import script from "./BusinessCoefficient.vue?vue&type=script&lang=js"
export * from "./BusinessCoefficient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c67702",
  null
  
)

export default component.exports